const isoDatePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
const displayDatePattern = /^(\d{2})-(\d{2})-(\d{4})$/;

export const formatDate = (value) => {
  const date = String(value || "").trim();

  if (!date) {
    return "-";
  }

  const isoMatch = date.match(isoDatePattern);
  if (isoMatch) {
    return `${isoMatch[3]}-${isoMatch[2]}-${isoMatch[1]}`;
  }

  const displayMatch = date.match(displayDatePattern);
  if (displayMatch) {
    return date;
  }

  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return date;
  }

  const day = String(parsedDate.getDate()).padStart(2, "0");
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const year = parsedDate.getFullYear();
  return `${day}-${month}-${year}`;
};

export const toInputDate = (value) => {
  const date = String(value || "").trim();

  if (!date) {
    return "";
  }

  const isoMatch = date.match(isoDatePattern);
  if (isoMatch) {
    return date;
  }

  const displayMatch = date.match(displayDatePattern);
  if (displayMatch) {
    return `${displayMatch[3]}-${displayMatch[2]}-${displayMatch[1]}`;
  }

  return "";
};
